import React from 'react'

export default (props) => 
    <svg {...props} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="22" height="22" rx="5" fill="#7DDE8B"/>
        <path d="M11 5V17" stroke="white" strokeWidth="3"/>
        <path d="M17 11L5 11" stroke="white" strokeWidth="3"/>
    </svg>
